import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useCarSubsidiariesApi } from "../../http/carSubsidiaries/api";
import { formatDateNumeric } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";
import VersionDialog from "../ui/VersionDialog";

type CarSubsidiaryHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const CarSubsidiaryHistoryDialog: FC<CarSubsidiaryHistoryDialogProps> = ({
  itemToShowVersionsId: itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const carSubsidiariesApi = useCarSubsidiariesApi();

  return (
    <HistoryDialog
      title={i18n.t.carSubsidiaries.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={carSubsidiariesApi.getCarSubsidiariesVersion}
      getHistory={carSubsidiariesApi.getCarSubsidiariesHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <VersionDialog.Table headers={headers}>
          {(dataVersion.current?.subsidiary?.id ?? null) !== (dataVersion.next.subsidiary?.id ?? null) && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.subsidiaries.singular}
                value={dataVersion.current?.subsidiary?.name}
                edited={dataVersion.next?.subsidiary?.name}
              />
            </tr>
          )}
          {dataVersion.current?.startDate != dataVersion.next.startDate && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.startDate}
                value={dataVersion.current && formatDateNumeric(dataVersion.current?.startDate, i18n.language)}
                edited={formatDateNumeric(dataVersion.next?.startDate, i18n.language)}
              />
            </tr>
          )}
          {(!dataVersion.current || dataVersion?.current?.endDate !== dataVersion.next.endDate) && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.endDate}
                value={dataVersion.current.endDate && formatDateNumeric(dataVersion.current?.endDate, i18n.language)}
                edited={dataVersion.next?.endDate && formatDateNumeric(dataVersion.next?.endDate, i18n.language)}
              />
            </tr>
          )}
        </VersionDialog.Table>
      )}
    />
  );
};

export default CarSubsidiaryHistoryDialog;
